import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../../services/authService';
import { toast } from 'react-toastify';

export default function LoginForm() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error('Username and password are required');
      return;
    }
    try {
      setLoading(true);
      const res = await loginUser(username, password);
      localStorage.setItem('ataservtoken', res.data.data.token);
      toast.success('Login successful');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full">
      <div className="mb-8 text-center">
        <h2 className="text-3xl font-semibold text-emerald-900">Sign in to Admin</h2>
        <p className="mt-2 text-sm text-emerald-500/80">
          Use your credentials to access the ATA Service management dashboard.
        </p>
      </div>
      <form
        onSubmit={handleSubmit}
        className="bg-white border border-emerald-100 rounded-2xl shadow-lg shadow-emerald-100/70 p-8 space-y-6"
      >
        <div className="space-y-2">
          <label className="block text-sm font-medium text-emerald-800">Username</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border border-emerald-100 bg-emerald-50/40 text-emerald-900 focus:outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-200 transition"
            placeholder="Enter your username"
          />
        </div>
        <div className="space-y-2">
          <label className="block text-sm font-medium text-emerald-800">Password</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-xl border border-emerald-100 bg-emerald-50/40 text-emerald-900 focus:outline-none focus:border-emerald-400 focus:ring-2 focus:ring-emerald-200 transition"
            placeholder="Enter your password"
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-emerald-500 hover:bg-emerald-600 focus:outline-none focus:ring-2 focus:ring-emerald-300 focus:ring-offset-2 focus:ring-offset-emerald-50 text-white py-3 rounded-xl font-medium shadow-lg shadow-emerald-200/80 disabled:opacity-60 disabled:cursor-not-allowed transition"
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
        <p className="text-xs text-center text-emerald-500/70">
          By signing in you agree to our terms of service and privacy policy.
        </p>
      </form>
    </div>
  );
}
